<!-- 首营商品列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <firstGoodsAction v-if="showStatus" ref="firstGoodsAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </firstGoodsAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :flagList="['categoryCode']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-input v-if="formOneValue.entityField == 'bgmId'" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList', 'bgmId', 'bgmId')" v-model="getRequestData.bgmName" :maxlength="$store.state.inputLength">
                        </el-input>
                        <el-cascader v-if="formOneValue.entityField == 'categoryCode'" ref="elCascader" :show-all-levels="false" :props="{ emitPath: false,checkStrictly:true }" v-model="getRequestData[formOneValue.entityField]"
                            :options="categoryList" filterable></el-cascader>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table :row-class-name="rowClassName" @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" size="mini" :data="returnData.list" border style="width: 100%" :height="tableHeight" :key="$store.state.tableNum"
                    highlight-current-row>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" show-overflow-tooltip :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">{{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}</span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <span v-else-if="tableValye.entityField == 'bgmActivestatus'">{{ $store.state.businessGoodsState[scope.row.bgmActivestatus].name }}</span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'ggmState'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.ggmState) }}</el-tag>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'goodType'">{{$common.getIsGsp(tableValye.formatterContent, scope.row.goodType) }}</el-tag>
                                <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="OCR识别上传" :visible.sync="diaContract" width="80vw">
            <span slot="title" class="dialog-footer" style="display: flex;">
                <h3>OCR识别上传</h3>
                <el-link style="margin-left: 10px;" :underline="false" type="danger">请上传药品注册证、再注册批件、医疗器械注册(支持PDF、JPGE、PNG等图片类型)</el-link>
            </span>

            <upDataImg v-if="diaContract" ref="upFile"></upDataImg>
            <div class="fileTable">
                <el-button class="btn" type="primary" style="margin-top: 4px;margin-bottom: 4px;" size="mini" @click="identifyFile">去提交</el-button>
            </div>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <!-- <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
        <img width="100%" :src="imgUrl+'/'+dialogImageUrl" alt="">
    </el-dialog> -->
        <el-drawer :close-on-press-escape="true" :visible.sync="matchGSPgoodSshow" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <matchGSPgoods v-if="matchGSPgoodSshow" ref="matchGSPgoods" @drawerCancel="drawerCancelmatchGSPgoodSshow" @handleSelectClick="handleSelectClick" @openFirstGoodsAction="openFirstGoodsAction" :pageShowData="pageShowData"
                :type="0">
            </matchGSPgoods>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import firstGoodsAction from "@/components/firstGoodsAction.vue";
import matchGSPgoods from "@/components/matchGSPgoods.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { firstGoodsAction, matchGSPgoods },
    data() {
        //这里存放数据
        return {

            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            selectData: [],
            pageShowData: [],
            formDataList: [],
            imgUrl: "", //图片根路径
            showStatus: false,
            actionData: {},
            DialogVisible: false,
            seId: "",
            sField: "",
            cmId: "",
            parentSearchData: {},
            seWidth: 0,
            seTitle: "",
            categoryList: [],
            diaContract: false,
            fileList: [],
            matchGSPgoodSshow: false,
            //-----------
            goodType: 0,
            ocrResults: [],
            formShow: false,
            //------------
            menuList: [],
            activeMenu: "all",
            isMenu:false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
        "getRequestData.stName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.stId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = ""
            if (row.focuson == 1) {
                rowName = "danger-row"; // 可以通过此处给选中行一个class，给自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 识别文件
        async identifyFile() {
            // 从 upDataImg 组件获取文件列表
            let fileList = []
            console.log(this.$refs.upFile.allUploadUrls)
            if (this.$refs.upFile.allUploadUrls.length > 0) {
                fileList = this.$refs.upFile.allUploadUrls
            }
            this.fileList = fileList
            console.log(this.fileList)
            // return
            if (fileList.length == 0) {
                this.$message({
                    message: "请选择文件",
                    type: "error",
                });
                return
            }
            let responseData = await this.$http.GSPgoodsocrRecognition({
                fileList: fileList,
                type: 0,
            })
            if (responseData.status == 200) {
                this.$message({
                    message: "识别成功",
                    type: "success",
                });
                this.diaContract = false
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async categoryquery() {
            let responseData = await this.$http.categoryquery({});
            if (responseData.status == 200) {
                this.categoryList = []
                if (responseData.result.length > 0) {
                    this.categoryList = this.handleJurisdiction(responseData.result)
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value = { ...value }
                    value['id'] = value['id']
                    value['value'] = value['pathCode']
                    value['label'] = value['categoryName']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },

        handleSelectionChange(val) {
            this.selectData = val
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        drawerCancelmatchGSPgoodSshow() {
            this.matchGSPgoodSshow = false;
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: {
                            isPenetrate,
                        }, //参数
                    },
                    "*"
                );
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem(
                        "selectBusinessGoodsEntryInfo"
                    );
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path);
            this.getButtonList();
            this.getDataTest(ss.jurId);
            this.categoryquery()
        },

        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids],
            });
            if (responseData.status == 200) {
                // this.formDataList = []
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                if (this.formShow) {
                    if (!this.showStatus) {
                        this.$nextTick(() => {
                            if (this.goodType == 1) {
                                //器械
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                            } else if (this.goodType == 2) {
                                //其他
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                            } else {
                                //商品
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        // console.log(v.jciName, /(器)/g.test(v.jciName));
                                        if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                            }
                            this.actionData = {
                                cate: 0,
                                formData: this.formDataList,
                                oldData: "",
                                orderId: "",
                                printSouce: "",
                                printJurId: "",
                                fatherType: false,
                                ocrResults: this.ocrResults,
                            };
                            this.formShow = false
                            this.showStatus = true;
                        })
                    }
                }
                await this.getMenuData()
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },

        openDataActionBox(cate) {
            this.formDataList = [];
            if (cate == 0) {
                //商品
                this.pageShowData.jurFormVoList &&
                    this.pageShowData.jurFormVoList.forEach((v) => {
                        // console.log(v.jciName, /(器)/g.test(v.jciName));
                        if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                    });
                this.actionData = {
                    cate: 0,
                    formData: this.formDataList,
                    oldData: "",
                    orderId: "",
                    printSouce: "",
                    printJurId: "",
                    fatherType: false,
                };
                this.showStatus = true;
            } else if (cate == 4) {
                //器械
                this.pageShowData.jurFormVoList &&
                    this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                    });
                this.actionData = {
                    cate: 0,
                    formData: this.formDataList,
                    oldData: "",
                    orderId: "",
                    printSouce: "",
                    printJurId: "",
                    fatherType: false,
                };
                this.showStatus = true;
            } else if (cate == 22) {
                //其他
                this.pageShowData.jurFormVoList &&
                    this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                    });
                this.actionData = {
                    cate: 0,
                    formData: this.formDataList,
                    oldData: "",
                    orderId: "",
                    printSouce: "",
                    printJurId: "",
                    fatherType: false,
                };
                this.showStatus = true;
            } else if (cate == 7) {
                //复制商品
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (this.selectData.length != 1) {
                    this.$message({
                        message: "请先选择您要操作的一条数据",
                        type: "error",
                    });
                    return false;
                }
                var olddataInfo = this.selectData[0]
                let dataInfo = JSON.parse(JSON.stringify(olddataInfo));
                this.pageShowData.jurFormVoList &&
                    this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                    });
                this.actionData = {
                    cate: cate,
                    formData: this.formDataList,
                    oldData: dataInfo,
                    orderId: dataInfo.ggmId,
                    printSouce: "",
                    printJurId: "",
                    fatherType: false,
                };
                this.showStatus = true;
            } else {
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (this.selectData.length == 0) {
                    this.$message({
                        message: "请先选择您要操作的数据",
                        type: "error",
                    });
                    return false;
                }
                let dataInfo
                if (this.selectData.length == 1 || cate == 1) {
                    if (this.selectData.length != 1 && cate == 1) {
                        this.$message({
                            message: "请先选择一条操作的数据",
                            type: "error",
                        });
                        return false;
                    }

                    this.$http.queryFirstGoodsInfo({
                        ids: this.selectData.map(item => item.ggmId)
                    }).then(res => {
                        if (res.status == 200) {

                            dataInfo = res.result
                            //药品类型0.药品1.器械2.其他
                            if (dataInfo.goodType == 1) {
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                                this.actionData = {
                                    cate: cate,
                                    formData: this.formDataList,
                                    oldData: dataInfo,
                                    orderId: dataInfo.ggmId,
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: false,
                                };
                            } else if (dataInfo.goodType == 2) {
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                                this.actionData = {
                                    cate: cate,
                                    formData: this.formDataList,
                                    oldData: dataInfo,
                                    orderId: dataInfo.ggmId,
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: false,
                                };
                            } else {
                                this.pageShowData.jurFormVoList &&
                                    this.pageShowData.jurFormVoList.forEach((v) => {
                                        if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                    });
                                this.actionData = {
                                    cate: cate,
                                    formData: this.formDataList,
                                    oldData: dataInfo,
                                    orderId: dataInfo.ggmId,
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: false,
                                };
                            }
                            this.showStatus = true;

                        } else {
                            this.$message.error(res.message)
                        }
                    })
                } else {
                    this.submitData()

                    // this.$message({
                    //    type: 'success',
                    //    message: '操作成功!'
                    // });
                    // this.getDataList()
                }

            }
        },
        async submitData() {
            var delData = {
                ids: this.selectData.map(item => item.ggmId),
            };
            let responseData = await this.$http.submitFirstGoods(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log("actionData", actionData.actionType);
            switch (actionData.actionType) {
                case 0:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 1:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 4:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 5:
                    this.diaContract = true;
                    this.sysBasicsgoodList = [];
                    break;
                case 6:
                    this.matchGSPgoodSshow = true;
                    break;
                case 7:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 22:
                    this.openDataActionBox(actionData.actionType);
                    break;
                case 15:
                    this.openFormDesign();
                    break;
            }
        },
        handleSelectClick(row, rightfromData, taskId) {
            let dataInfo = row;
            console.log(row, this.type, '选择的商品123');
            // 确保 formDataList 是一个数组
            if (!Array.isArray(this.formDataList)) {
                this.formDataList = [];
            }
            // 清空数组，避免重复添加
            this.formDataList = [];

            // 根据类型过滤表单配置
            const isQixie = rightfromData['标题'] && rightfromData['标题'].includes('器械');
            console.log(isQixie ? '器械类型' : '药品类型');

            this.pageShowData.jurFormVoList &&
                this.pageShowData.jurFormVoList.forEach((v) => {
                    if (isQixie) {
                        // 器械类型：排除包含"商品"的表单
                        if (!/(商品)/g.test(v.jciName)) this.formDataList.push(v);
                    } else {
                        // 药品类型：排除包含"器"的表单
                        if (!/(器)/g.test(v.jciName)) this.formDataList.push(v);
                    }
                });

            // 构建 actionData，将已有数据作为 oldData 传递
            // firstGoodsAction 组件会根据 cate: 7 处理部分字段重置，其他字段保持默认值
            this.actionData = {
                cate: 7,
                formData: this.formDataList,
                oldData: dataInfo,
                orderId: dataInfo.ggmId || '',
                printSouce: "",
                printJurId: "",
                fatherType: false,
                taskId: taskId
            };

            console.log(this.actionData, 'actionData1233321');
            // 通知父组件打开 firstGoodsAction
            this.openFirstGoodsAction(this.actionData);
        },
        // 打开 firstGoodsAction 组件
        openFirstGoodsAction(actionData) {
            this.actionData = actionData;
            this.showStatus = true;
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path);
            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            );
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getFirstGoodsList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getMenuData() {
            const params = {codeClassify: 0}
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },
        // 删除数据（批量）
        delDataAction() {
            if (this.selectData.length == 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除选中的数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.selectData.map(item => item.ggmId),
                    };
                    let responseData = await this.$http.delFirstGoodsList(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();

        },
        // 检查并处理OCR识别结果
        checkOCRResult(event) {
            console.log(event.data, "测试");
            if (event.data.type == 'OCR_message') {
                if (event.data.data) {
                    this.ocrResults = event.data.data.ocrResults
                    this.goodType = event.data.data.goodType
                    if (this.pageShowData.jurFormVoList) {
                        if (!this.showStatus) {
                            this.$nextTick(() => {
                                if (this.goodType == 1) {
                                    //器械
                                    this.pageShowData.jurFormVoList &&
                                        this.pageShowData.jurFormVoList.forEach((v) => {
                                            if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                        });
                                } else if (this.goodType == 2) {
                                    //其他
                                    this.pageShowData.jurFormVoList &&
                                        this.pageShowData.jurFormVoList.forEach((v) => {
                                            if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                                        });
                                } else {
                                    //商品
                                    this.pageShowData.jurFormVoList &&
                                        this.pageShowData.jurFormVoList.forEach((v) => {
                                            // console.log(v.jciName, /(器)/g.test(v.jciName));
                                            if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                                        });
                                }
                                this.actionData = {
                                    cate: 0,
                                    formData: this.formDataList,
                                    oldData: "",
                                    orderId: "",
                                    printSouce: "",
                                    printJurId: "",
                                    fatherType: false,
                                    ocrResults: this.ocrResults,
                                };
                                this.showStatus = true;
                            })
                        }
                    } else {
                        this.formShow = true
                    }

                }
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        console.log(window, "测试");
        console.log(window.delMenu, "测试");
        this.getPageInfo();
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.isMenu = window.global_config.isLeftMenuBgm||false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        window.addEventListener('message', this.checkOCRResult);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { window.removeEventListener('message', this.checkOCRResult); }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    deactivated() {
        window.removeEventListener('message', this.checkOCRResult);
    }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
    position: relative;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y:auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}
</style>